/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Image, Header as BaseHeader } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import AuthLayout from '../../../layouts/components/AuthLayout';
import { LoginForm } from '../containers';

const Logo = styled(Image)`
  margin: 0 auto 3em auto;
`;

const Header = styled(BaseHeader)`
  &.header {
    font-size: 36px !important;
    text-align: center;
  }
`;

const LoginPage = ({ match }) => (
  <AuthLayout>
    <Logo src="/images/appotime-logo-dashboard.png" />
    <Header as="h1">
      <FormattedMessage id="pages.login.title" defaultMessage="Login" />
    </Header>
    <LoginForm />
  </AuthLayout>
);

export default LoginPage;
